var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52858 15.9999C14.4879 15.9999 18.8293 9.84965 18.8293 4.49891V3.97613C19.673 3.39769 20.4067 2.69083 21 1.88505C20.2195 2.22103 19.3869 2.43899 18.5332 2.53082C19.4396 2.02398 20.1177 1.22604 20.4409 0.285977C19.5928 0.747913 18.6713 1.08011 17.7111 1.27002C16.0706 -0.348607 13.3422 -0.430896 11.5936 1.08551C10.4686 2.06382 9.99148 3.53124 10.3438 4.92943C6.87324 4.76899 3.63903 3.23746 1.44714 0.716497C0.294998 2.56025 0.887449 4.9246 2.79561 6.09795C2.10694 6.07282 1.43287 5.90474 0.822245 5.60596V5.66746C0.821699 7.58812 2.26409 9.245 4.27564 9.63435C3.64228 9.7929 2.97855 9.81391 2.33516 9.69591C2.90299 11.3428 4.53009 12.4683 6.38058 12.4942C4.85496 13.6215 2.96401 14.2289 1.01958 14.2163C0.690679 14.2163 0.328891 14.1856 0 14.1549C1.93655 15.3654 4.21554 16.0079 6.54503 15.9999",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/TwitterLogo.fe968b078eccbfb89fda074dfe791d01.svg";
export { ForwardRef as ReactComponent };